import React, { useState } from 'react';
import './Login.css';

interface LoginProps {
  onLoginSuccess: (user: any, token: string) => void;
  onForgotPassword?: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess, onForgotPassword }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    try {
      const response = await fetch('/api/login/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        localStorage.setItem('token', data.token);
        onLoginSuccess(data.user, data.token);
      } else {
        setError(data.message || 'Usuário ou senha inválidos');
      }
    } catch (err) {
      setError('Erro ao conectar ao servidor.');
      console.error('Erro de login:', err);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-left">
        <img src="/logo-fks.png" alt="FKS" className="logo-fks" />
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Usuário"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
            <span className="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"><path fill="#bdbdbd" d="M12 12c2.7 0 8 1.34 8 4v2H4v-2c0-2.66 5.3-4 8-4Zm0-2a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"/></svg>
            </span>
          </div>
          <div className="input-group">
            <input
              type="password"
              placeholder="Senha"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <span className="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"><path fill="#bdbdbd" d="M12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm6-6V9a6 6 0 1 0-12 0v2a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2Zm-8-2a4 4 0 1 1 8 0v2H8V9Zm10 11H6v-7h12v7Z"/></svg>
            </span>
          </div>
          <button type="submit">Entrar</button>
          {error && <div className="error">{error}</div>}
          
          <div className="forgot-password-container">
            <button 
              type="button" 
              className="forgot-password-link"
              onClick={onForgotPassword}
            >
              Primeiro Acesso / Esqueci minha senha
            </button>
          </div>
        </form>
      </div>
      <div className="login-right">
        <img src="/truck.jpg" alt="Caminhão" className="login-image" />
      </div>
    </div>
  );
};

export default Login;
